import { FC, useEffect, useId, useState } from 'react';
import { Progress } from 'antd-v5';
import styled from './index.module.scss';

interface IProps {
    title: string;
    list: {
        text: string;
        unit: string;
        number: number;
    }[];
}

const ProgressGroup: FC<IProps> = ({ title, list }) => {
    const id = useId().replaceAll(':', 'a'); // 因为：无法使用选择器
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneA = AniContainer.create({
                onEnter: () => {
                    setEnter(true);
                },
                onLeave: () => {
                    // setEnter(false);
                },
                triggerElement: `#${id}`,
                triggerHook: 1,
                offset: '0%',
                duration: '100%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene(sceneA);
        }
    }, []);
    if (list.length === 0) return <></>;

    const total = list[0].number;
    return (
        <div className={styled.ProgressGroup} id={id}>
            <p className="title">{title}</p>
            {list.length > 0 && (
                <ul className="progress_box">
                    {list.map((item, index) => (
                        <li key={item.text} className="progress_item">
                            <div className="left">
                                <Progress
                                    strokeColor={index === list.length - 1 ? '#3F0' : '#666'}
                                    strokeWidth={8}
                                    percent={enter ? (item.number / total) * 100 : 0}
                                    showInfo={false}
                                />
                                <p>{item.text}</p>
                            </div>
                            <div className={`right ${index === list.length - 1 ? 'active' : ''}`}>
                                {item.number}&nbsp;
                                {item.unit}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ProgressGroup;
